import classNames from 'clsx';

const MarkdownColumn = function ({
  width,
  className,
  alignX,
  alignY,
  style,
  children,
}: React.PropsWithChildren<{
  width?: string;
  className?: string;
  alignY?: string;
  alignX?: string;
  style?: React.CSSProperties;
}>) {
  return (
    <div
      className={classNames('w-full h-full markdown-child-root', className)}
      style={{
        ...style,
        alignSelf: (() => {
          switch (alignX) {
            case 'left':
              return 'flex-start';
            case 'right':
              return 'flex-end';
            case 'center':
              return 'center';
            default:
              return alignX;
          }
        })(),
        justifySelf: (() => {
          switch (alignY) {
            case 'top':
              return 'flex-start';
            case 'bottom':
              return 'flex-end';
            case 'center':
              return 'center';
            default:
              return alignY;
          }
        })(),
      }}
    >
      {children}
    </div>
  );
};

MarkdownColumn.attributes = ['width', 'className', 'alignY', 'alignX', 'style'];

export { MarkdownColumn };
